// theme-sources/js/sections/mini-swiper.js
import Swiper from "swiper";
import { Autoplay, Pagination } from "swiper/modules";

const DEBUG = false;

const logger = {
  info(message, payload) {
    if (typeof window === "undefined") return;
    if (window.__ZIGGY_DEBUG__ !== true) return;
    if (!DEBUG) return;
    console.info(`[MiniSwiper] ${message}`, payload ?? "");
  },
};

function initMiniSwipers(root = document) {
  logger.info("root", root);
  root.querySelectorAll("[data-mini-swiper]").forEach(initOne);
}

function initOne(el) {
  if (el.swiper) return;

  const slides = el.querySelectorAll(".swiper-slide").length;
  if (slides <= 1) return;

  logger.info("init", el);

  const sliderType = el.dataset.sliderType || "";
  const isCartSlider = sliderType === "cart";

  const desktopEnabled = el.dataset.desktopSlider === "true";
  const autoplayDelay = Number(el.dataset.autoplayDelay) || 0;

  let loop = true;
  if (el.dataset.loop) {
    loop = el.dataset.loop === "true";
  }

  const desktopSlidesPerView = Number(el.dataset.desktopSlidesPerView) || 2;
  const mobileSlidesPerView = Number(el.dataset.mobileSlidesPerView) || 1;

  let swiper = null;
  const mq = window.matchMedia("(min-width: 768px)");

  const enable = () => {
    if (swiper) return;

    logger.info("enable", {
      sliderType,
      isCartSlider,
    });

    const config = {
      modules: [Pagination, ...(autoplayDelay ? [Autoplay] : [])],
      loop,
      grabCursor: true,
      speed: 600,
      spaceBetween: 12,
      autoplay: autoplayDelay
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : undefined,
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true,
      },
    };

    if (isCartSlider) {
      config.slidesPerView = "auto";
    } else {
      config.slidesPerView = mobileSlidesPerView;
      config.slidesOffsetAfter = 20;
      config.slidesOffsetBefore = 20;
      /*config.spaceBetween = 10;*/
      config.breakpoints = {
        600: { slidesPerView: mobileSlidesPerView },
        768: desktopEnabled ? { slidesPerView: desktopSlidesPerView } : {},
      };
    }

    swiper = new Swiper(el, config);
  };

  const disable = () => {
    if (!swiper) return;
    logger.info("disable");
    swiper.destroy(true, true);
    swiper = null;
  };

  const update = () => {
    if (mq.matches && !desktopEnabled) {
      disable();
    } else {
      enable();
    }
  };

  mq.addEventListener("change", update);
  update();
}

if (typeof window !== "undefined") {
  window.Ziggy = window.Ziggy || {};
  window.Ziggy.initMiniSwipers = initMiniSwipers;
}

initMiniSwipers();
